export const unmaskMoney = (value: string) => {
  if (value.includes('/')) {
    return value;
  }

  const numericValue = value.replace('R$', '').replace(',', '.');
  return parseFloat(numericValue).toString();
};
